import ActionsCell from "./ActionsCell";
import { textFilter } from "helpers/tableFilters";

const columns = [
  {
    Header: "Nivel",
    accessor: "level",
    filterable: true,
    filterMethod: textFilter("level"),
  },
  {
    Header: "Número Cuenta",
    accessor: "number",
    filterable: true,
    filterMethod: textFilter("number"),
  },
  {
    Header: "Nombre Cuenta",
    accessor: "name",
    filterable: true,
    filterMethod: textFilter("name"),
  },
  {
    Header: "Tipo de Cuenta",
    accessor: "accountTypeLabel",
    filterable: true,
    filterMethod: textFilter("accountTypeLabel"),
  },
  {
    Header: "Cuenta Padre",
    accessor: "parentAccountLabel",
    filterable: true,
    filterMethod: textFilter("parentAccountLabel"),
  },
  {
    Header: "Cuenta Mayor",
    accessor: "ledgerAccountLabel",
    filterable: true,
    filterMethod: textFilter("ledgerAccountLabel"),
  },
  {
    Header: "Código Agrupador (SAT)",
    accessor: "satCode",
    filterable: true,
    filterMethod: textFilter("satCode"),
  },
  {
    Header: "Último Nivel",
    accessor: "lastLevelLabel",
    filterable: true,
    filterMethod: textFilter("lastLevelLabel"),
  },
  {
    Header: "Afectable",
    accessor: "affectsSpendingLabel",
    filterable: true,
    filterMethod: textFilter("affectsSpendingLabel"),
  },
  {
    Header: "Acciones",
    filterable: false,
    Cell: ActionsCell,
  },
];

export default columns;
